"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { polymorphicFactory } from "../../../core/factory/polymorphic-factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import { useAppShellContext } from "../AppShell.context.mjs";
import AppShell_module_default from "../AppShell.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/AppShell/AppShellSection/AppShellSection.tsx
const AppShellSection = polymorphicFactory((_props) => {
	const { classNames, className, style, styles, vars, grow, mod, ...others } = useProps("AppShellSection", null, _props);
	const ctx = useAppShellContext();
	return /* @__PURE__ */ jsx(Box, {
		mod: [{ grow }, mod],
		...ctx.getStyles("section", {
			className,
			style,
			classNames,
			styles
		}),
		...others
	});
});
AppShellSection.classes = AppShell_module_default;
AppShellSection.displayName = "@mantine/core/AppShellSection";
//#endregion
export { AppShellSection };

//# sourceMappingURL=AppShellSection.mjs.map